import React from 'react';
import {useParams, useLocation} from 'react-router-dom';
import Breadcrumb from './Breadcrumb';

interface BreadcrumbItem {
  key: string;
  text: string;
  href: string;
}

interface MenuItem {
  meta: {
    title: string;
    showBreadcrumb?: boolean;
    showDateRangePicker?: boolean;
    showComparisonDatePicker?: boolean;
    breadcrumbs?: BreadcrumbItem[];
    parameters?: string[];
  };
}

interface BreadcrumbWrapperProps {
  menuItem: MenuItem;
  children: React.ReactNode;
}

const BreadcrumbWrapper: React.FC<BreadcrumbWrapperProps> = ({
    menuItem,
    children
}) => {
    const params = useParams();
    const location = useLocation();

    // Only show breadcrumbs if explicitly enabled and breadcrumb data exists
    const shouldShowBreadcrumbs = menuItem.meta.showBreadcrumb && 
                               menuItem.meta.breadcrumbs && 
                               menuItem.meta.breadcrumbs.length > 0;

    if (!shouldShowBreadcrumbs) {
        return <>{children}</>;
    }

    // Resolve parameters in breadcrumb hrefs
    const resolveHref = (href: string): string => {
        if (!menuItem.meta.parameters || menuItem.meta.parameters.length === 0) {
            return href;
        }

        let resolvedHref = href;
        
        // Replace each parameter with its actual value from the URL
        menuItem.meta.parameters.forEach(paramName => {
            const paramValue = params[paramName];
            if (paramValue) {
                resolvedHref = resolvedHref.replace(`:${paramName}`, paramValue);
            }
        });

        return resolvedHref;
    };

    // Create resolved breadcrumb items
    const resolvedBreadcrumbs = menuItem.meta.breadcrumbs!.map(item => ({
        ...item,
        href: resolveHref(item.href)
    }));

    return (
        <div className="breadcrumb-wrapper">
            <Breadcrumb 
                items={resolvedBreadcrumbs} 
                showDateRangePicker={menuItem.meta.showDateRangePicker}
                showComparisonDatePicker={menuItem.meta.showComparisonDatePicker}
            />
            <div className="breadcrumb-content">
                {children}
            </div>
        </div>
    );
};

export default BreadcrumbWrapper;
